export default __webpack_public_path__ + "static/media/vote-for-your-weekend.a6d43654.svg";